import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CardAnalyticsQuery, UserSnapshotResponse, UserDistributionResponse, UserTrendsResponse, UserGeoResponse } from './user-analytics.model';
import { UserAnalyticsService } from './user-analytics.abstract.service';

@Injectable({
    providedIn: 'root',
})
export class UserAnalyticsImplService implements UserAnalyticsService {
    private baseUrl = `${environment.API_GATEWAY_URL}/cards/admin/analytics`;

    constructor(@Inject('HTTP_CLIENT') public http: HttpClient) {}

    getSnapshot(): Observable<UserSnapshotResponse> {
        return this.http.get<UserSnapshotResponse>(`${this.baseUrl}/snapshot`);
    }

    getDistribution(query?: CardAnalyticsQuery): Observable<UserDistributionResponse> {
        return this.http.get<UserDistributionResponse>(`${this.baseUrl}/distribution`, {
            params: this.buildParams(query),
        });
    }

    getTrends(query?: CardAnalyticsQuery): Observable<UserTrendsResponse> {
        return this.http.get<UserTrendsResponse>(`${this.baseUrl}/trends`, {
            params: this.buildParams(query),
        });
    }

    getGeo(): Observable<UserGeoResponse> {
        return this.http.get<UserGeoResponse>(`${this.baseUrl}/geo`);
    }

    private buildParams(query?: CardAnalyticsQuery): HttpParams {
        let params = new HttpParams();
        if (!query) return params;

        if (query.period) {
            params = params.set('period', query.period);
        }
        if (query.from) {
            params = params.set('from', query.from);
        }
        if (query.to) {
            params = params.set('to', query.to);
        }

        return params;
    }
}

export const USER_ANALYTICS_SERVICE_PROVIDER = {
    provide: UserAnalyticsService,
    useClass: UserAnalyticsImplService,
};
